module.exports = __webpack_public_path__ + "img/52.5a6d61b5.webp";